<template>
  <div class="container">
    <div class="d-md-flex justify-content-lg-around">
      <div class="col-12 col-md-3 mt-1 p-0 m-0 mt-1 pr-md-4">
        <profile />
      </div>
      <div class="col-12 col-md-7 p-0 m-0 ml-3 ml-md-0 mt-1">
        <new-post @reloadPosts="reloadPosts" />
        <feed ref="feed" />
      </div>
      <div class="col-2 d-none d-md-block p-0 mt-1">
        <advertisement />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NewPost from './../../components/panel/NewPost/Form'
import Profile from './../../components/panel/Profile'
import Feed from './../../components/panel/Feed'
import Advertisement from './../../components/panel/Advertisement'

export default {
  components: {
    "new-post": NewPost,
    "profile": Profile,
    "feed": Feed,
    "advertisement": Advertisement,
  },
  computed: {
    ...mapGetters({
      user: 'getCurrentUser'
    })
  },
  methods: {
    reloadPosts: function () {
      this.$refs.feed.loadPosts();
    }
  }
}
</script>
